import { createFileRoute } from '@tanstack/react-router';

import {
  PageContentLayout,
  PageContentLayoutHeader,
  PageContentLayoutMain,
} from '@/components/layout';
import { ChangePasswordForm, UserInfoCard } from '@/components/profile';
import { CustomTitle } from '@/components/typography';
import '@/styles/route-profile.scss';

export function ProfileScreen() {
  return (
    <PageContentLayout>
      <PageContentLayoutHeader>
        <CustomTitle level="h1">Profile</CustomTitle>
      </PageContentLayoutHeader>
      <PageContentLayoutMain>
        <div className="profile-screen">
          <UserInfoCard />
          <ChangePasswordForm />
        </div>
      </PageContentLayoutMain>
    </PageContentLayout>
  );
}

export const Route = createFileRoute('/_auth/profile')({
  component: ProfileScreen,
});
